import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useSEO } from '../../utils/seo';

export default function EgitimlerPage() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  // SEO Configuration
  useSEO({
    title: 'İlkyardım Eğitimi Hatay İskenderun | Yangın Güvenliği Yüksekte Çalışma - ASSA Akademi',
    description: 'Hatay İskenderun, Payas, Dörtyol ve Antakya\'da temel ilkyardım eğitimi, ilkyardım güncelleme, yangın güvenliği, yüksekte çalışma ve hijyen eğitimleri. MEB onaylı sertifikalı eğitimler. ☎ 0850 346 27 72',
    keywords: 'ilkyardım eğitimi hatay, iskenderun ilkyardım kursu, payas ilkyardım eğitimi, dörtyol yangın güvenliği, antakya iş güvenliği, yangın eğitimi iskenderun, yüksekte çalışma eğitimi hatay, hijyen eğitimi payas, MYK danışmanlığı dörtyol, ilkyardım sertifikası antakya',
    canonical: '/egitimler',
    ogTitle: 'İlkyardım Eğitimi Hatay İskenderun | Yangın Güvenliği - ASSA Akademi',
    ogDescription: 'MEB onaylı ilkyardım, yangın güvenliği ve iş güvenliği eğitim programları. Hatay İskenderun, Payas, Dörtyol, Antakya\'da profesyonel eğitim.',
    ogImage: 'https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/168d15a60f9fa69a47dd6f5cc2c64efc.png',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "@id": "https://www.hatayilkyardım.com.tr/egitimler#webpage",
      "url": "https://www.hatayilkyardım.com.tr/egitimler",
      "name": "İlkyardım Eğitimi Hatay İskenderun - ASSA Akademi Eğitim Programları",
      "description": "Hatay İskenderun, Payas, Dörtyol ve Antakya'da sunulan iş güvenliği ve mesleki eğitim programları",
      "isPartOf": {
        "@id": "https://www.hatayilkyardım.com.tr/#website"
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Ana Sayfa",
            "item": "https://www.hatayilkyardım.com.tr/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Eğitimler",
            "item": "https://www.hatayilkyardım.com.tr/egitimler"
          }
        ]
      },
      "mainEntity": {
        "@type": "ItemList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "item": {
              "@type": "Course",
              "name": "Temel İlkyardım Eğitimi",
              "description": "MEB onaylı 16 saatlik temel ilkyardım eğitimi - CPR, kanama kontrolü, kırık-çıkık müdahalei",
              "provider": {"@type": "Organization", "name": "ASSA Akademi", "url": "https://www.hatayilkyardım.com.tr"},
              "timeRequired": "PT16H",
              "educationalCredentialAwarded": "MEB Onaylı İlkyardım Sertifikası"
            }
          },
          {
            "@type": "ListItem",
            "position": 2,
            "item": {
              "@type": "Course",
              "name": "İlkyardım Güncelleme Eğitimi",
              "description": "İlkyardım sertifikası yenileme eğitimi - 8 saat",
              "provider": {"@type": "Organization", "name": "ASSA Akademi"},
              "timeRequired": "PT8H"
            }
          },
          {
            "@type": "ListItem",
            "position": 3,
            "item": {
              "@type": "Course",
              "name": "İlkyardım Eğitici Eğitimi",
              "description": "İlkyardım eğitmeni olmak için profesyonel eğitici eğitimi - 40 saat",
              "provider": {"@type": "Organization", "name": "ASSA Akademi"},
              "timeRequired": "PT40H"
            }
          },
          {
            "@type": "ListItem",
            "position": 4,
            "item": {
              "@type": "Course",
              "name": "Yangın Güvenliği Eğitimi",
              "description": "İş yerlerinde yangın güvenliği ve söndürme teknikleri eğitimi",
              "provider": {"@type": "Organization", "name": "ASSA Akademi"},
              "timeRequired": "PT8H"
            }
          },
          {
            "@type": "ListItem",
            "position": 5,
            "item": {
              "@type": "Course",
              "name": "Yüksekte Çalışma Eğitimi",
              "description": "IRATA L3 eğitmenlerle yüksekte güvenli çalışma teknikleri",
              "provider": {"@type": "Organization", "name": "ASSA Akademi"},
              "timeRequired": "PT16H"
            }
          },
          {
            "@type": "ListItem",
            "position": 6,
            "item": {
              "@type": "Course",
              "name": "Hijyen Eğitimleri",
              "description": "Gıda hijyeni ve iş yeri hijyen standartları eğitimi",
              "provider": {"@type": "Organization", "name": "ASSA Akademi"},
              "timeRequired": "PT8H"
            }
          }
        ]
      }
    }
  });

  const whatsappNumber = '905354971053';
  const handleWhatsAppClick = (egitim: string) => {
    const message = `Merhaba, ${egitim} hakkında bilgi almak istiyorum.`;
    window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const egitimler = [
    {
      id: 1,
      category: 'ilkyardim',
      title: 'Temel İlkyardım Eğitimi',
      description: 'Acil durumlarda hayat kurtarıcı temel ilkyardım müdahalelerini öğrenin. CPR, kanama kontrolü, kırık-çıkık müdahaleleri ve daha fazlası.',
      duration: '16 Saat',
      image: 'https://public.readdy.ai/ai/img_res/ffe29da31b43192d41e7d69f69d4b61e.jpg',
      features: ['CPR Eğitimi', 'Kanama Kontrolü', 'Kırık-Çıkık Müdahalesi', 'Yanık Müdahalesi']
    },
    {
      id: 2,
      category: 'ilkyardim',
      title: 'İlkyardım Güncelleme Eğitimi',
      description: 'Daha önce almış olduğunuz ilkyardım sertifikanızı yenilemek için güncelleme eğitimi.',
      duration: '8 Saat',
      image: 'https://readdy.ai/api/search-image?query=first%20aid%20refresher%20training%20course%20medical%20professionals%20reviewing%20emergency%20procedures%20modern%20training%20room%20with%20medical%20supplies%20clean%20bright%20simple%20background%20professional%20atmosphere&width=800&height=600&seq=train102&orientation=landscape',
      features: ['Bilgi Tazeleme', 'Yeni Teknikler', 'Pratik Uygulamalar', 'Sertifika Yenileme']
    },
    {
      id: 3,
      category: 'ilkyardim',
      title: 'İlkyardım Eğitici Eğitimi',
      description: 'İlkyardım eğitmeni olmak isteyenler için profesyonel eğitici eğitimi programı.',
      duration: '40 Saat',
      image: 'https://readdy.ai/api/search-image?query=first%20aid%20instructor%20training%20professional%20trainer%20teaching%20group%20of%20future%20instructors%20advanced%20medical%20training%20equipment%20professional%20classroom%20clean%20simple%20background%20educational%20setting&width=800&height=600&seq=train103&orientation=landscape',
      features: ['Eğitim Teknikleri', 'Sunum Becerileri', 'Müfredat Hazırlama', 'Eğitici Sertifikası']
    },
    {
      id: 4,
      category: 'yangin',
      title: 'Yangın Güvenliği Eğitimi',
      description: 'İş yerlerinde yangın güvenliği, yangın söndürme teknikleri ve acil durum prosedürleri eğitimi.',
      duration: '8 Saat',
      image: 'https://readdy.ai/api/search-image?query=fire%20safety%20training%20instructor%20demonstrating%20fire%20extinguisher%20to%20workers%20in%20safety%20gear%20industrial%20workplace%20with%20fire%20safety%20equipment%20clean%20simple%20background%20professional%20training&width=800&height=600&seq=train104&orientation=landscape',
      features: ['Yangın Söndürme', 'Tahliye Prosedürleri', 'Yangın Önleme', 'Acil Durum Yönetimi']
    },
    {
      id: 5,
      category: 'is-guvenligi',
      title: 'Yüksekte Çalışma Eğitimi',
      description: 'Yüksekte güvenli çalışma teknikleri, düşme önleme ve kişisel koruyucu donanım kullanımı eğitimi. IRATA L3 eğitmenlerimiz tarafından verilmektedir.',
      duration: '16 Saat',
      image: 'https://readdy.ai/api/search-image?query=height%20safety%20training%20workers%20learning%20fall%20protection%20equipment%20and%20harness%20usage%20in%20professional%20training%20facility%20safety%20equipment%20visible%20clean%20simple%20background%20industrial%20setting&width=800&height=600&seq=train105&orientation=landscape',
      features: ['Düşme Önleme', 'Emniyet Kemeri Kullanımı', 'İskele Güvenliği', 'Kurtarma Teknikleri']
    },
    {
      id: 6,
      category: 'hijyen',
      title: 'Hijyen Eğitimleri',
      description: 'Gıda hijyeni, kişisel hijyen ve iş yeri hijyen standartları eğitimi.',
      duration: '8 Saat',
      image: 'https://readdy.ai/api/search-image?query=hygiene%20training%20course%20instructor%20teaching%20food%20safety%20and%20sanitation%20practices%20to%20workers%20in%20clean%20modern%20training%20room%20hygiene%20materials%20visible%20simple%20background%20professional%20setting&width=800&height=600&seq=train106&orientation=landscape',
      features: ['Gıda Hijyeni', 'Kişisel Hijyen', 'Temizlik Standartları', 'Sağlık Mevzuatı']
    },
    {
      id: 7,
      category: 'mesleki',
      title: 'Mesleki Eğitimler',
      description: 'Üniversite onaylı mesleki yeterlilik belgesi almak için gerekli eğitim programları. Sertifikalarınız E-Devlet üzerinden görüntülenebilir.',
      duration: 'Değişken',
      image: 'https://readdy.ai/api/search-image?query=vocational%20training%20professional%20skills%20development%20course%20with%20students%20learning%20technical%20skills%20modern%20training%20facility%20with%20equipment%20clean%20simple%20background%20educational%20atmosphere&width=800&height=600&seq=train107&orientation=landscape',
      features: ['Üniversite Onaylı', 'E-Devlet\'te Görülebilir', 'Pratik Uygulamalar', 'MYK Belgesi']
    },
    {
      id: 8,
      category: 'mesleki',
      title: 'MYK Danışmanlığı',
      description: 'Mesleki Yeterlilik Kurumu süreçleri için profesyonel danışmanlık hizmeti.',
      duration: 'Danışmanlık',
      image: 'https://readdy.ai/api/search-image?query=professional%20consulting%20service%20business%20advisor%20meeting%20with%20clients%20in%20modern%20office%20discussing%20certification%20process%20clean%20professional%20simple%20background%20business%20setting&width=800&height=600&seq=train108&orientation=landscape',
      features: ['Süreç Yönetimi', 'Belgelendirme Desteği', 'Başvuru Yardımı', 'Takip Hizmeti']
    }
  ];

  const categories = [
    { id: 'all', name: 'Tüm Eğitimler', icon: 'ri-grid-line' },
    { id: 'ilkyardim', name: 'İlkyardım', icon: 'ri-heart-pulse-line' },
    { id: 'yangin', name: 'Yangın Güvenliği', icon: 'ri-fire-line' },
    { id: 'is-guvenligi', name: 'İş Güvenliği', icon: 'ri-shield-line' },
    { id: 'hijyen', name: 'Hijyen', icon: 'ri-hand-sanitizer-line' },
    { id: 'mesleki', name: 'Mesleki Eğitim', icon: 'ri-briefcase-line' }
  ];

  const filteredEgitimler = selectedCategory === 'all' 
    ? egitimler 
    : egitimler.filter(e => e.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-gradient-to-r from-gray-900 to-gray-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="mb-8">
            <Link to="/" className="text-teal-400 hover:text-teal-300 flex items-center text-sm whitespace-nowrap">
              <i className="ri-arrow-left-line mr-2"></i>
              Ana Sayfaya Dön
            </Link>
          </nav>
          <h1 className="text-5xl font-bold mb-4">Eğitim Programlarımız</h1>
          <p className="text-xl text-gray-300 max-w-3xl">
            Hatay İskenderun'da profesyonel eğitim programları ile iş güvenliği ve mesleki gelişim alanında hizmet veriyoruz
          </p>
        </div>
      </header>

      {/* Category Filter */}
      <section className="bg-gray-50 py-8 sticky top-0 z-30 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex overflow-x-auto space-x-4 pb-2">
            {categories.map(cat => (
              <button
                key={cat.id}
                onClick={() => setSelectedCategory(cat.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-full font-semibold transition-all whitespace-nowrap ${
                  selectedCategory === cat.id
                    ? 'bg-teal-600 text-white shadow-lg scale-105'
                    : 'bg-white text-gray-700 hover:bg-gray-100 hover:scale-105'
                }`}
              >
                <i className={`${cat.icon} text-lg`}></i>
                <span>{cat.name}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Training Cards - 4 Column Grid */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {filteredEgitimler.map((egitim, index) => (
              <div 
                key={egitim.id} 
                className="group bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-3 cursor-pointer flex flex-col"
                style={{
                  animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
                }}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={egitim.image}
                    alt={`${egitim.title} - ASSA Akademi Hatay`}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <div className="absolute top-3 right-3 bg-teal-600 text-white px-3 py-1.5 rounded-full text-xs font-bold whitespace-nowrap shadow-lg">
                    {egitim.duration}
                  </div>
                </div>

                <div className="p-5 flex flex-col flex-1">
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors line-clamp-2">
                    {egitim.title}
                  </h3>
                  <p className="text-gray-600 mb-4 text-xs leading-relaxed line-clamp-3">
                    {egitim.description}
                  </p>

                  <div className="mb-4 flex-1">
                    <div className="grid grid-cols-1 gap-1.5">
                      {egitim.features.slice(0, 3).map((feature, idx) => (
                        <div key={idx} className="flex items-center text-xs text-gray-600">
                          <i className="ri-check-line text-teal-600 mr-1.5 text-sm"></i>
                          <span className="line-clamp-1">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <button
                    onClick={() => handleWhatsAppClick(egitim.title)}
                    className="w-full bg-teal-600 hover:bg-teal-700 text-white px-4 py-2.5 rounded-lg font-semibold transition-all flex items-center justify-center space-x-2 whitespace-nowrap group-hover:shadow-lg text-sm mt-auto"
                  >
                    <i className="ri-whatsapp-line text-base"></i>
                    <span>Bilgi Al</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gradient-to-r from-teal-600 to-teal-700 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Hangi Eğitimin Size Uygun Olduğundan Emin Değil Misiniz?
          </h2>
          <p className="text-xl text-teal-50 mb-8">
            Uzman ekibimiz size en uygun eğitim programını belirlemenizde yardımcı olacaktır
          </p>
          <button
            onClick={() => handleWhatsAppClick('Eğitim Danışmanlığı')}
            className="bg-white hover:bg-gray-100 text-teal-600 px-8 py-4 rounded-lg font-bold text-lg transition-all inline-flex items-center space-x-2 whitespace-nowrap hover:scale-105"
          >
            <i className="ri-customer-service-line text-xl"></i>
            <span>Ücretsiz Danışmanlık Alın</span>
          </button>
        </div>
      </section>

      {/* Floating WhatsApp Button */}
      <button
        onClick={() => handleWhatsAppClick('Eğitimler')}
        className="fixed bottom-6 right-6 w-14 h-14 bg-teal-600 hover:bg-teal-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all z-40 flex items-center justify-center hover:scale-110"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </button>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}